export default __webpack_public_path__ + "static/upkeep_icon_gray-5d3e918a9729d8103ba5058baa8d6d27.svg";